import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function vevent(_this__u8e3s4, eventName) {
  return vevent$1().new_com_lightningkite_kiteui_views_direct__no_name_provided__n3oe8f_k$(_this__u8e3s4, eventName);
}
function vprop(_this__u8e3s4, eventName, get, set) {
  return vprop$1().new_com_lightningkite_kiteui_views_direct__no_name_provided__n8xr4e_k$(_this__u8e3s4, eventName, get, set);
}
var vevent$1Class;
function vevent$1() {
  if (vevent$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor($this_vevent, $eventName) {
        return new.target.new_com_lightningkite_kiteui_views_direct__no_name_provided__n3oe8f_k$($this_vevent, $eventName);
      }
      static new_com_lightningkite_kiteui_views_direct__no_name_provided__n3oe8f_k$($this_vevent, $eventName) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vevent.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vevent.eventsBack_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vevent.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
    }
    initMetadataForClass($);
    vevent$1Class = $;
  }
  return vevent$1Class;
}
function assign($this, value) {
  if (equals($this.$get_1($this.$this_vprop_1), value))
    return Unit_instance;
  $this.$set_1($this.$this_vprop_1, value);
  $this.invokeAllListeners_uusj2y_k$();
}
var vprop$1Class;
function vprop$1() {
  if (vprop$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor($this_vprop, $eventName, $get, $set) {
        return new.target.new_com_lightningkite_kiteui_views_direct__no_name_provided__n8xr4e_k$($this_vprop, $eventName, $get, $set);
      }
      static new_com_lightningkite_kiteui_views_direct__no_name_provided__n8xr4e_k$($this_vprop, $eventName, $get, $set, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_vprop_1 = $this_vprop;
        $box.$get_1 = $get;
        $box.$set_1 = $set;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vprop.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vprop.eventsBack_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vprop.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
      set_value_84k4y1_k$(value) {
        return assign(this, value);
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_84k4y1_k$(_set____db54di);
      }
      get_value_j01efc_k$() {
        return this.$get_1(this.$this_vprop_1);
      }
      *set_rua9jy_k$(value, $completion) {
        assign(this, value);
        return Unit_instance;
      }
      set_revjhg_k$(value, $completion) {
        return this.set_rua9jy_k$(value, $completion);
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    vprop$1Class = $;
  }
  return vprop$1Class;
}
//region block: exports
export {
  vevent as vevent2d70lzbz6q2i1,
  vprop as vpropka48um9uweps,
};
//endregion

//# sourceMappingURL=helpers.commonHtml.mjs.map
